import {
  Checkbox as CheckboxMui,
  CheckboxProps as MuiCheckboxProps,
  FormControlLabel,
  SxProps,
  Theme,
} from '@mui/material';
import { styled } from '@mui/material';

import CheckboxCheckedIcon from '~/assets/icons/svgs/checkbox-ticked.svg?react';
import CheckboxIcon from '~/assets/icons/svgs/checkbox-unticked.svg?react';
import { COLORS } from '~/styles/colors';

interface CustomCheckboxProps extends Omit<MuiCheckboxProps, 'label'> {
  label?: string;
  checkBoxSx?: SxProps<Theme>;
}

export default function Checkbox({
  checked,
  onChange,
  className,
  label,
  size = 'small',
  sx,
  checkBoxSx = {},
  ...rest
}: CustomCheckboxProps) {
  return (
    <StyledFormControlLabel
      sx={sx}
      control={
        <CheckboxMui
          disableRipple
          className={className}
          checked={checked}
          onChange={onChange}
          size={size}
          icon={<CheckboxIcon />}
          checkedIcon={<CheckboxCheckedIcon />}
          sx={checkBoxSx}
          {...rest}
        />
      }
      label={label}
    />
  );
}

const StyledFormControlLabel = styled(FormControlLabel)(() => ({
  margin: 0,
  gap: '4px',
  '.MuiFormControlLabel-label': {
    color: COLORS.textMain,
  },
}));
